import {Table} from '@/components/common-components/components/table';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {useCallback, useEffect, useRef, useState} from 'react';
import {isPublicKeywordMagicV2} from '@/utils/url';
import {SkeletonRingLoader, Button as ButtonCom, SkeletonHorizontalLoaderGray} from '@/components/common-components/components';
import {Pagination} from '@/components/common-components/components/pagination';
import {isNil} from 'lodash';
import {formatFloat, formatNumber, numberWithCommas} from '@/utils/number';
import {Tooltip, Checkbox, Collapse, Empty, Radio, Dropdown, Menu, Input} from 'antd';
import {LoadingOutlined} from '@ant-design/icons';
import {Spin, Space} from 'antd';
import {VerticalBar} from '@/components/common-components/components/vertical-bar/index';
import {faCaretDown, faCaretRight, faCircle} from '@fortawesome/pro-solid-svg-icons';
import {useStore} from '@/store/root-store';
import {useRouter} from 'next/router';
import {Button} from '@/components/common-components/v2/Button';
import {faCirclePlus, faCircleCheck, faCircleInfo} from '@fortawesome/pro-duotone-svg-icons';
import {CreateList} from '../main-page/createlist';
import {getSingleUrlParam} from '@/utils/url';
import Link from 'next/link';
import {KeDeleteModal} from '../main-page/component/keDeleteModal';
import {AddKeywordDropdownV2} from '@/components/common-components/v2/addKeywordDropdown';
import {ChartOverlayBanner} from '../ke-common-components-v2/chartOverlayBanner';
import moment from 'moment';
import {faPen, faRotateRight} from '@fortawesome/pro-regular-svg-icons';
import {faFileArrowDown} from '@fortawesome/pro-regular-svg-icons';
import {apiError, downloadExportFileV2, downloadExportFile} from '@/utils/api';
import {CONTENT_ASSISTANT_API} from '@/api/ContentAssistant';
import {notification} from '@/utils/notification';
import {InfoContainer, InfoText, ListContainer, ListItem, MenuItem, ProjectSelectMenu, SearchContainer, Text, Value} from '../../site-explorer-page/detail-page/StyledComponent';
import {Search} from 'react-feather';
import {toJS} from 'mobx';
import ReactEcharts from 'echarts-for-react';
import {renderToString} from 'react-dom/server';
import {SortOrder} from 'antd/lib/table/interface';

export const getBgAndColorTooltip =key=>{
  switch (key) {
    case 'commercial':
      return {
        background: '#F1AA3E1A',
        color: '#F1AA3E',
        tooltipTitle: <TooltipDescription><StyledTooltipHeading>Commercial</StyledTooltipHeading><br />The user wants to investigate brands or services.</TooltipDescription>,
      };
    case 'navigational':
      return {
        background: '#B98CE41A',
        color: '#B98CE4',
        tooltipTitle: <TooltipDescription><StyledTooltipHeading>Navigational</StyledTooltipHeading><br />The user wants to find a specific page or site.</TooltipDescription>,
      };
    case 'informational':
      return {
        background: '#34AEF31A',
        color: '#34AEF3',
        tooltipTitle: <TooltipDescription><StyledTooltipHeading>Informational</StyledTooltipHeading><br />The user wants to find an answer to a specific question.</TooltipDescription>,
      };
    case 'transactional':
      return {
        background: '#1F91681A',
        color: '#1F9168',
        tooltipTitle: <TooltipDescription><StyledTooltipHeading>Transactional</StyledTooltipHeading><br />The user wants to complete an action (conversion).</TooltipDescription>,
      };
    default:
      return {
        background: '',
        color: '',
        tooltipTitle: <TooltipDescription><StyledTooltipHeading></StyledTooltipHeading>No any search intent found.</TooltipDescription>,
      };
  }
};

export const CollapseTable = observer(() => {
  const {
    keywordResearcherV2: {
      keywordDetails: {
        loadTermsMatchMagicDetails,
        loadTermSearchMagicDetails,
        getMagicTableDataV2,
        getMagicTableData,
        magicTableLoadingV2,
        magicTableLoading,
        setCreateListModalData,
        loadKeywordDetailList,
        loadingMagicTreeV2,
        loadTermAggregationKeywordsDetail,
        loadMagicKeywordsData,
        keSelectedKeyword,
        setTermsMathRepolling,
        magicTableParams,
        setMagicTableParams,
        setTreeListParams,
        treeListParams,
        createListData,
        magicTableDataUrlV2,
        loadingMagicTreeUrlV2,
        loadSearchIntentList,
        loadSearchIntentListV2,
        setRefreshKw,
        kmtRefetchKeyword,
        fetchingSearchIntent,
        getAndUpdateSearchIntentList,
        magicTableDataUrl,
        kmtTermsSearchFilter,
        magicTableDataV2,
      },
    },
    contentOptimizer: {pages: {projects, getAllProjects}},
  } = useStore('');
  const {settings: {customer: {profile: {address}, setAuthModal}}}= useStore('');
  const {keywordResearcherV2: {deleteKeywordLoading, deletedKeywordListData, setModaValue, openKeywordDeleteModal, keywordDeleteId}} = useStore('');

  const {keywordResearcherV2: {getKeywordListDetail, keywordRankTracker: {
    getListWithoutRepoll,
    getRankTrackerList,
    setKrtSearchTerm,
  }}} = useStore('');
  const {home: {isChild}} = useStore('');
  const tableRef = useRef(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [fileType, setFileType] = useState('csv');
  const [radioButtonValue, setRadioButtonValue] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [customRows, setCustomRows] = useState(1);
  const [popoverVisibile, setPopoverVisibile] = useState(false);
  const [projectsList, setProjectsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [treeList, setTreeList] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [activeSort, setActiveSort] = useState('');
  const router = useRouter();
  const countryCode = getSingleUrlParam('countryCode') || address?.defaultLocation;
  const countryName = getSingleUrlParam('countryName') || address?.countryName;
  const locationId = getSingleUrlParam('locationId') == 'null' ? 0 : getSingleUrlParam('locationId');
  const tableName = getSingleUrlParam('table');
  const listNameParam = getSingleUrlParam('listName');
  const isMagicTool = router?.pathname?.includes('/keyword-magic-tool');
  const listId = isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 0 : router.query?.keyword?.length ? router.query.keyword[0] : '';
  const keyword = router.query?.keyword?.length ? router.query.keyword[isMagicTool && !tableName ? 0 : 1]?.replaceAll('+', ' ') : '';
  const closeModal= ()=>{
    setModaValue(false);
  };
  const currentCustomerId = localStorage.getItem('currentCustomerId');
  const showSvColumn = tableName !== 'related_keywords' && isMagicTool || tableName == 'keyword_variation' || tableName == 'questions';
  const URL = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';
  const onDeleteKeyword= async ()=>{
    try {
      await deletedKeywordListData(keywordDeleteId, false);
      closeModal();
      if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
        router.push(`/research/keyword-magic-tool`);
      } else {
        router.push(`/research/keyword-researcher`);
      }
    } catch (error) {
      const errorMessage = apiError(error) as string;
      notification.error('', errorMessage);
    }
  };
  useEffect(() => {
    getAllProjects();
  }, []);
  useEffect(() => {
    if (projects?.length) {
      setProjectsList(toJS(projects));
    }
  }, [JSON.stringify(projects)]);
  useEffect(() => {
    if ((isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count !== null) {
      if (totalCount < (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count) {
        setTotalCount((isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count);
      }
    }
  }, [getMagicTableDataV2?.count, getMagicTableData?.count]);

  useEffect(() => {
    return () => {
      setTotalCount(0);
    };
  }, []);

  const initialLoad = async () => {
    if (keyword) {
      setMagicTableParams({
        ...magicTableParams,
        page: 1,
        page_size: 100,
      });
      setTreeListParams({
        page: 1,
        page_size: 100,
      });
      let results =null;
      if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
        await loadTermSearchMagicDetails({
          keyword: keyword,
          country_code: countryCode?.toLowerCase(),
          ...(tableName == 'questions' && {question_search: true}),
          location_id: locationId,
        });
        const data = {keyword: keyword};
        if (countryCode) {
          data['country_code'] = countryCode?.toLowerCase();
        }
        if (locationId) {
          data['location_id'] = locationId;
        }
        results= await loadTermAggregationKeywordsDetail(data);
      } else {
        loadTermsMatchMagicDetails({keyword: keyword, listId: listId});
        const magicData = {keyword: keyword, listId: listId};
        if (locationId) {
          magicData['locationId'] = locationId;
        } else {
          magicData['country_code'] = countryCode ? countryCode : '';
        }
        results= await loadMagicKeywordsData(magicData);
      }

      if (results?.length) {
        const formatResult = results?.map((item, idx) => {
          return {
            title: `${item?.word}`,
            sv: item?.sv,
            key: `${idx}`,
            children: [],
          };
        });
        setTreeList(formatResult);
      }
    }
  };
  useEffect(() => {
    if (keyword) {
      setTreeList([]);
      initialLoad();
    }
  }, [keyword, countryCode]);

  const recallListingApi = async () => {
    const data = {keyword: keyword};
    if (countryCode) {
      data['country_code'] = countryCode?.toLowerCase();
    }
    if (locationId) {
      data['location_id'] = locationId;
    }
    const results= await loadTermAggregationKeywordsDetail(data);
    if (results?.length) {
      const formatResult = results?.map((item, idx) => {
        return {
          title: `${item?.word}`,
          sv: item?.sv,
          key: `${idx}`,
          children: [],
        };
      });
      setTreeList(formatResult);
    }
  };

  useEffect(() => {
    if (!magicTableDataV2?.shouldRepoll && !magicTableLoadingV2) {
      recallListingApi();
    }
  }, [magicTableDataV2?.shouldRepoll]);

  useEffect(() => {
    if (!router?.pathname?.includes('public')) {
      setKrtSearchTerm('');
      getListWithoutRepoll(100);
    }
    setTermsMathRepolling(true);
    return () => {
      setTermsMathRepolling(false);
    };
  }, []);

  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [extendedTerm, setExtendedTerm] = useState('');
  const [extendedKey, setExtendedKey] = useState('');
  const [search, setSearch] = useState('');
  const [loader, setLoader] = useState(false);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

  const [checked, stIsChecked] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (search === '') {
      setTotalCount((isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count);
    }
  }, [loadingMagicTreeV2, getMagicTableDataV2?.count, getMagicTableData?.count]);

  const setListName = value => {
    setCreateListModalData({
      ...createListData,
      listName: value,
    });
  };

  const setNewKeyword = value => {
    setCreateListModalData({
      ...createListData,
      newKeyword: value,
    });
  };

  const setSelectedCountry = value => {
    setCreateListModalData({
      ...createListData,
      selectedCountry: value,
    });
  };

  const handleCreateContent = async (item: any) => {
    setLoader(true);
    let response = null;
    for (let i = 0; i < selectedKeyword.length; i++) {
      const pagePayload = {
        keywords_list: [selectedKeyword[i]],
        ...(countryCode ? {country_code: countryCode?.toUpperCase()} : {country_code: ''}),
        ...(locationId && {location_id: locationId}),
        title: selectedKeyword[i],
      };
      try {
        response = await CONTENT_ASSISTANT_API.createPage(item?.id ? Object.assign(pagePayload, {project_id: item.id}) : pagePayload);
      } catch (error) {
        setLoader(false);
        const errorMessage = apiError(error) as string;
        notification.error('', errorMessage);
        return null;
      }
    }

    if (response?.uuid) {
      window.open(`${URL}/content/seo-content-assistant/${response?.uuid}`, '_blank');
      setLoader(false);
    } else {
      setLoader(false);
      return;
    }
  };

  const updateTreeData = (list: any[], key: string, children: any[]): any[] =>
    list?.map(node => {
      if (node?.key === key) {
        return {
          ...node,
          children,
        };
      }
      if (node?.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }
      return node;
    });

  const onLoadData = async (value, arr?: any) => {
    setExtendedTerm('');
    setSearch('');
    setPageNumber(1);
    const key = value?.split('/')[0];
    const finalKw = value?.split('/')[1];
    setExtendedKey(key);
    if (finalKw) {
      setExtendedTerm(finalKw);
      setMagicTableParams({
        ...magicTableParams,
        page: 1,
      });
      if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
        loadTermSearchMagicDetails({
          keyword: keyword ? keyword : keSelectedKeyword,
          country_code: countryCode?.toLowerCase(),
          ...(tableName == 'questions' && {question_search: true}),
        }, finalKw);
      } else {
        loadTermsMatchMagicDetails({keyword: keyword ? keyword : keSelectedKeyword, listId: listId}, finalKw);
      }
      if (arr?.length< 3) {
        let data = {};
        if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
          data = {
            keyword: keyword ? keyword : keSelectedKeyword,
          };
        } else {
          data = {
            keyword: keyword ? keyword : keSelectedKeyword,
            listId: listId,
          };
        }
        if (countryCode) {
          data['country_code'] = countryCode?.toLowerCase();
        }
        let results = null;
        if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
          results = await loadTermAggregationKeywordsDetail(data, finalKw);
        } else {
          results = await loadMagicKeywordsData(data, finalKw);
        }
        if (results?.length) {
          const formatResults = results?.map((item, idx) => {
            return {
              title: `${item?.word}`,
              sv: item?.sv,
              key: `${key}-${idx}`,
              children: [],
            };
          });
          setTreeList(origin =>
            updateTreeData(origin, key, formatResults),
          );
        }
      }
    } else {
      if (arr?.length==1) {
        if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
          loadTermSearchMagicDetails({
            keyword: keyword ? keyword : keSelectedKeyword,
            country_code: countryCode?.toLowerCase(),
            ...(tableName == 'questions' && {question_search: true}),
          }, finalKw);
        } else {
          loadTermsMatchMagicDetails({keyword: keyword ? keyword : keSelectedKeyword, listId: listId}, finalKw);
        }
      }
    }
  };

  const getKdBgAndColor =value => {
    if (value>=0 && value<=10) {
      return '#1FAC47';
    } else if (value>=11 && value<=30) {
      return '#BFE15E';
    } else if (value>=31 && value<=70) {
      return '#FF8536';
    } else {
      return '#F44343';
    }
  };

  const setKeywordsList = (event, keyword) => {
    if (event.target.checked) {
      setSelectedKeyword(selectedKeyword => [...selectedKeyword, keyword]);
    } else {
      setSelectedKeyword(selectedKeyword.filter(item=> item !== keyword ));
    }
  };

  const setBulkKeywordsList = event => {
    stIsChecked(event?.target?.checked);
    const keywordsArr = (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.results?.map(item => item.keyword);
    const updatedKeyword = keywordsArr?.filter(element => selectedKeyword?.indexOf(element) < 0);

    if (event.target.checked) {
      setSelectedKeyword(selectedKeyword => [...selectedKeyword, ...updatedKeyword]);
    } else {
      setSelectedKeyword([]);
    }
  };

  useEffect(() => {
    if (selectedKeyword.length === (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.results?.length) {
      stIsChecked(true);
    } else {
      stIsChecked(false);
    }
  }, [selectedKeyword]);

  const findAndUpdateNestedObj = (entireObj, keyToFind, valToFind, moreResults) => {
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (nestedValue && nestedValue[keyToFind] === valToFind) {
        nestedValue?.children?.push(...moreResults);
      }
      return nestedValue;
    });
    return entireObj;
  };

  const handleScroll = async () => {
    if (!loadingMagicTreeV2) {
      setTreeListParams({
        page: treeListParams?.page + 1,
        page_size: 2000,
      });
      const data = {keyword: keSelectedKeyword, listId: listId};
      if (countryCode) {
        data['countryCode'] = countryCode;
      }
      const results = await loadTermAggregationKeywordsDetail(data, extendedTerm);
      if (results?.length) {
        const formatResults = results?.map((item, idx) => {
          return {
            title: `${item?.word}`,
            sv: item?.sv,
            key: `${extendedKey}-${idx}`,
            children: [],
          };
        });

        if (extendedKey) {
          const updatedList = findAndUpdateNestedObj(treeList, 'key', extendedKey, formatResults);
          setTreeList(updatedList);
        } else {
          setTreeList(origin => [...origin, ...formatResults]);
        }
      }
    }
  };

  const handleRefetchSearchIntentList = value => {
    if (isPublicKeywordMagicV2()) {
      setAuthModal(true, false);
    } else {
      if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
        loadSearchIntentListV2(value, locationId, countryCode?.toLocaleLowerCase());
      } else {
        loadSearchIntentList(value, locationId, countryCode?.toLocaleLowerCase());
      }
    }
  };

  const handleRefetch = record => {
    if (!isPublicKeywordMagicV2()) {
      setRefreshKw(record?.keyword);
      const listApiData = {
        data: {keyword: keyword, listId: listId},
        term: extendedTerm,
      };
      kmtRefetchKeyword(record?.keyword, locationId || null, countryCode || null, listApiData);
    }
  };

  const handleBulkRefetchSearchIntentList = keywords => {
    if (isPublicKeywordMagicV2()) {
      setAuthModal(true, false);
    } else {
      getAndUpdateSearchIntentList(keywords.map(keyword => keyword?.trim()), locationId, countryCode?.toLocaleLowerCase());
    }
  };

  const handleRenderCollapse = (data: any, parentKeyword?: string) => {
    let dummyArray = [];
    return (
      <CollapseMainScroll className='collapseStyle' style={{height: `${tableRef?.current?.offsetHeight < 650 ? 650 : tableRef?.current?.offsetHeight}px`}}>
        <GroupingCollapse ghost onChange={key => onLoadData(key, dummyArray)}
          expandIcon={({isActive}) => isActive ? dummyArray?.length<3 ? <FontAwesomeIcon onClick={() => {}} icon={faCaretDown} style={{color: '#FF8536'}}/>:'' :
            dummyArray?.length<3 ? <FontAwesomeIcon onClick={() => {}} icon={faCaretRight}/> : ''}
          accordion>
          {data ? data.map(grouping => {
            let parameter = parentKeyword ? parentKeyword : '';
            parameter = parameter+`${parameter ? ',' : ''}${grouping?.title}`;
            dummyArray = grouping?.key?.split('-');
            return (
              <Collapse.Panel
                header={
                  <PanelHeader>
                    <span style={{maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis'}}>{grouping?.title ? grouping.title : '-'}</span>
                    {showSvColumn && <span>{grouping?.sv || grouping?.sv == 0 ? formatNumber(grouping.sv) : '-'}</span>}
                  </PanelHeader>
                }
                key={`${grouping?.key}/${parameter}`}>
                {grouping?.children?.length || !loadingMagicTreeV2 ?dummyArray?.length < 3 ? handleRenderCollapse(grouping?.children, `${parentKeyword ? `${parentKeyword},` : ''}${grouping?.title}`) : '' : <SkeletonRingLoader />}
              </Collapse.Panel>
            );
          }) :
            ''}
        </GroupingCollapse>
        {data?.length >= 2000 ? <ButtonWrapper border color='textGrayLight' textColor='#121212' style={{margin: '10px auto 0'}} loading={loadingMagicTreeV2} onClick={() => handleScroll()}>Load more</ButtonWrapper> : ''}
      </CollapseMainScroll>
    );
  };

  const getPast12Months = () => {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ];

    const today = new Date();
    const pastMonths = [];

    for (let i = 0; i < 12; i++) {
      const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      pastMonths.unshift(`${month} ${year}`);
    }

    return pastMonths;
  };

  const months = getPast12Months();

  const options = histSv => {
    return {
      tooltip: {
        show: true,
        appendToBody: true,
        trigger: 'axis',
        formatter: params => {
          const dataIndex = params[0]?.dataIndex; // Get index of the hovered data point
          const value = params[0]?.value; // Get value of the hovered data point
          const month = months[dataIndex]; // Get corresponding month from months array
          return renderToString(<div style={{display: 'flex', flexDirection: 'column'}}>
            <div>{month}</div>
            <div style={{display: 'flex'}}>
              <div dangerouslySetInnerHTML={{__html: params[0]?.marker}} />
              <div style={{fontWeight: 500}}>{value}</div>
            </div>
          </div>);
        },
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLine: { // Remove x-axis line
          show: false,
        },
        axisTick: { // Remove x-axis ticks
          show: false,
        },
        axisLabel: { // Remove x-axis labels
          show: false,
        },
        splitLine: { // Remove x-axis split lines
          show: false,
        },
      },
      yAxis: {
        type: 'value',
        axisLine: { // Remove y-axis line
          show: false,
        },
        axisTick: { // Remove y-axis ticks
          show: false,
        },
        axisLabel: { // Remove y-axis labels
          show: false,
        },
        splitLine: { // Remove y-axis split lines
          show: false,
        },
      },
      grid: {
        bottom: 0,
        top: 0,
        left: 0,
        right: 0,
      },
      series: [
        {
          data: histSv,
          type: 'line',
          lineStyle: {
            color: '#2D6CCA', // Change color of the line
            width: 1.2, // Increase width of the line
            type: 'solid', // Line style: solid, dashed, or dotted
          },
          symbol: 'none', // Remove markers on each data point
          tooltip: { // Tooltip settings for this series
            show: true, // Ensure tooltip is enabled for this series
          },
        },
      ],
    };
  };

  const columns = (isMagicTool): any => [{
    title: () => <HeaderCheckboxContainer>
      {!isPublicKeywordMagicV2() && <Checkbox onChange={e=> setBulkKeywordsList(e)} checked={checked}/>}
      <Tooltip color={'#121212'} title={<div><strong>Keyword</strong>
        <div>Words and phrases that searchers enter into search engines to discover content.</div>
      </div>}><HeadingWrapper style={{marginLeft: 11, marginTop: 5}}>KEYWORD</HeadingWrapper></Tooltip></HeaderCheckboxContainer>,
    key: 'keyword',
    dataIndex: 'keyword',
    align: 'left',
    sorter: false,
    fixed: screenWidth >= 800 ? 'left' as 'left' : false,
    width: isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 200 : 400,
    render: (keyword:any) => {
      const selectedListForDropdown = [];
      const checkAllLists = [];
      if (getKeywordListDetail?.length) {
        getKeywordListDetail?.map(item => {
          if (item?.keywords?.includes(keyword)) {
            selectedListForDropdown?.push(`${item?.name}`);
          }
          item?.keywords?.map(z => {
            if (z) {
              checkAllLists.push(z);
            }
          });
        });
      }
      const linkId = isMagicTool || tableName ? 'new' : listId;
      const isLocationId = `?locationId=${locationId}`;
      const detailLink = isPublicPage ? `/research/keyword-researcher-public/${linkId}/${keyword?.replaceAll(' ', '+')}${isLocationId}${listNameParam ? `&listName=${listNameParam}` : ''}&public_hash=${publicHash}` :
        `/research/keyword-researcher/${linkId}/${keyword?.replaceAll(' ', '+')}${isLocationId}${listNameParam ? `&listName=${listNameParam}` : ''}&countryCode=${countryCode || ''}&countryName=${countryName}${isMagicTool &&
          (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? '&fromKmt=1' : ''}${isChild ? `&customerId=${currentCustomerId ? currentCustomerId: ''}` : ''}`;
      return <CheckbocContainer>
        {!isPublicKeywordMagicV2() && <Checkbox checked={selectedKeyword?.find(item => item == keyword)} onChange={e=> setKeywordsList(e, keyword)}/>}
        <Tooltip title={keyword}>
          {isPublicKeywordMagicV2() ? <span className='ellipsesSpan'>{keyword}</span> :
            <>
              <AddKeywordDropdownV2
                keList={getKeywordListDetail}
                rankTrackerList={getRankTrackerList?.results}
                targetKeyword={keyword}
                setNewKeyword={data => setNewKeyword(data)}
                triggerNode={checkAllLists?.includes(keyword) ? <FontAwesomeIcon icon={faCircleCheck} style={{paddingLeft: '15px', cursor: 'pointer', color: '#2AC155'}}/> : <FontAwesomeIcon icon={faCirclePlus} style={{paddingLeft: '15px', cursor: 'pointer'}}/>}
              />
              <Link legacyBehavior href={detailLink} passHref>
                <LinkWrapper style={{pointerEvents: selectedKeyword?.length > 0 ? 'none' : 'auto', fontSize: '14px', marginLeft: 11}} rel='noreferrer'> {keyword}</LinkWrapper>
              </Link>
            </>}
        </Tooltip>
      </CheckbocContainer>;
    },
  },
  {
    title: <Tooltip color={'#121212'} title={<div><strong>Search Intent</strong>
      <div>The purpose of a search in a search engine. Intents can be read by the search engine algorithms to show the proper results and SERP features.</div>
    </div>}><HeadingWrapper>SEARCH<br/>INTENT</HeadingWrapper></Tooltip>,
    key: 'searchIntent',
    dataIndex: 'searchIntent',
    align: 'left' as 'left',
    sorter: false,
    width: 100,
    render: (_, data: any) =>{
      return ((isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? data?.searchIntent : data?.searchIntentList)?.length ? <SerchIntnetStyled>
        {(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? data?.searchIntent : data?.searchIntentList)?.map((items, idx)=> {
          const result = getBgAndColorTooltip(items);
          return <Tooltip title={result?.tooltipTitle} key={idx}><SearchIntentWrapper cololAndBg={result}>{items?.split('')[0]?.toUpperCase() || '-'}</SearchIntentWrapper></Tooltip>;
        })}
      </SerchIntnetStyled> : (data?.searchIntentLoading) ? <SkeletonHorizontalLoaderGray lightLoader width='40px' height= '15px' skeletonHeight='10px' align='center'/> : <BlueText onClick={()=> handleRefetchSearchIntentList(data?.keyword)}>Show</BlueText>);
    },
  },
  {
    title: () => <>
      <Tooltip color={'#121212'} title={<div><strong>Search Volume</strong>
        <div>The average number of monthly searches for a given keyword over a 12-month period. Use sort icon to display results in ascending or descending order.</div>
      </div>
      }><HeadingWrapper>SV</HeadingWrapper></Tooltip>
    </>,
    key: 'sv',
    dataIndex: 'sv',
    ...((!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && {sorter: (a: any, b: any) => a.sv - b.sv, showSorterTooltip: false}),
    ...(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') && {sortFieldName: 'sv', sorter: true, sortOrder: (activeSort?.includes('sv') ? activeSort?.startsWith('-') ? 'descend' : 'ascend' : false) as SortOrder}),
    width: 80,
    render: (_, data: any) => {
      return <div style={{display: 'flex', alignItems: 'center'}}>
        {!isNil(data?.sv) ? (data?.sv < 1000 ? data?.sv?.toFixed(0) : String(formatNumber(data?.sv, 1))?.replace('.0', '')) : '-'}</div>;
    },
  },
  {
    title: <Tooltip color={'#121212'} title={<div>
      <div>Highlights the competitive pressure from other sites targeting the same keyword.</div>
    </div>}><HeadingWrapper>COMPETITOR PRESSURE</HeadingWrapper></Tooltip>,
    key: 'kd',
    dataIndex: 'kd',
    align: 'left',
    width: isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 80 : 60,
    ...((!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && {sorter: (a: any, b: any) => isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? (a.difficulty - b.difficulty) : (a.kd - b.kd), showSorterTooltip: false}),
    render: (_, data: any) => {
      const tableVal = isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? data?.difficulty : data?.kd;
      const color = getKdBgAndColor((tableVal)?.toFixed(0) || 0);
      return <div>
        {(tableVal != null || tableVal != undefined) ? <PillContainer background={`${color}1A`}>
          <FontAwesomeIcon icon={faCircle} color={color} width={7}/>&nbsp;{tableVal?.toFixed(0)}
        </PillContainer> : <p style={{marginLeft: '20px'}}>-</p>}
      </div>;
    },
  },
  {...(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') && {
    title: <HeadingWrapper>HSV TREND</HeadingWrapper>,
    key: 'hsv_trend',
    dataIndex: 'hsv_trend',
    align: 'left' as 'left',
    sorter: false,
    width: 100,
    render: (_, data: any) =>{
      return <ReactEcharts
        style={{width: '60px', height: '15px'}}
        option={options(data?.histSv)}
      />;
    },
  })},
  {
    title: () => <Tooltip color={'#121212'} title={<div><strong>Cost per Click</strong>
      <div>Average price in USD advertisers pay for a user’s click on an ad triggered by a given keyword (Google Ads). Use sort icon to display results in ascending or descending order.</div>
    </div>}><HeadingWrapper>CPC</HeadingWrapper></Tooltip>,
    key: 'cpc',
    dataIndex: 'cpc',
    align: isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 'left' as 'left' : 'center' as 'center',
    width: isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 50 : 120,
    ...((!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && {sorter: (a: any, b: any) => a.cpc - b.cpc, showSorterTooltip: false}),
    ...(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') && {sortFieldName: 'cpc', sorter: true, sortOrder: (activeSort?.includes('cpc') ? activeSort?.startsWith('-') ? 'descend' : 'ascend' : false) as SortOrder}),
    render: cpc => <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: isMagicTool && (!tableName || tableName === 'keyword_variation' || tableName === 'questions') ? '' : 'center',
      }}
    >
      <div style={{display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', marginRight: '15px'}}>
        <span style={{minWidth: '68px', textAlign: 'right'}}>
          {!isNil(cpc) ? `$${formatFloat(cpc, 1)}` : '-'}
        </span>
        <VerticalBar
          cpc={cpc}
          maxCpc={100}
        />
      </div>
    </div>,
  },
  {
    title: () => <>
      <Tooltip color={'#121212'} title={<div><strong>PPCD</strong>
        <div>The level of difficulty of ranking for a paid keyword against advertisers bidding on the same keyword within their PPC campaigns.</div>
      </div>}>
        <HeadingWrapper>PPCD</HeadingWrapper>
      </Tooltip>
    </>,
    key: 'ppcd',
    ...(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') && {sortFieldName: 'ppcd', sorter: true, sortOrder: (activeSort?.includes('ppcd') ? activeSort?.startsWith('-') ? 'descend' : 'ascend' : false) as SortOrder}),
    dataIndex: 'ppcd',
    width: isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? 10 : 50,
    render: (_, data: any) => {
      return <div style={{display: 'flex', alignItems: 'center', justifyContent: isMagicTool ? 'center' : 'center'}}>
        {!isNil(data?.ppcd) ? String(formatNumber(data?.ppcd, 1))?.replace('.0', '') : '-'}</div>;
    },
  },
  {...((!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && {
    title: () => <>
      <HeadingWrapper>UPDATED</HeadingWrapper>
    </>,
    key: 'lastUpdatedAt',
    dataIndex: 'lastUpdatedAt',
    sorter: false,
    width: 140,
    render: (_, data: any) => {
      return <div style={{display: 'flex', alignItems: 'center'}}>
        {data?.lastUpdatedAt ? moment(data?.lastUpdatedAt)?.fromNow() : 'Refresh'}&nbsp;
        {data?.processingStatus == 'PENDING' ? <FontAwesomeIconStyled color={'#8860D4'} icon={faRotateRight} /> : <FontAwesomeIcon onClick={() => handleRefetch(data)} style={{cursor: 'pointer'}} icon={faRotateRight}/>}
      </div>;
    },
  })},
  ];

  const handlePaginationChange = (page, pageSize) => {
    // getPageSize(pageSize);
    setPageNumber(page);
    setMagicTableParams({
      ...magicTableParams,
      page: page,
      page_size: pageSize,
    });
    if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
      loadTermSearchMagicDetails({
        keyword: keyword, search,
        location_id: locationId,
        country_code: countryCode?.toLowerCase(),
        ...(tableName == 'questions' && {question_search: true}),
      }, extendedTerm);
    } else {
      loadTermsMatchMagicDetails({keyword: keyword, listId: listId, search}, extendedTerm);
    }
  };


  const antIconWt = <LoadingOutlined style={{fontSize: 16, color: 'white'}} spin />;
  const onChangeRadioButton = useCallback(
    e => setRadioButtonValue(e.target.value),
    [],
  );
  const onChangeFileType = useCallback(
    e => setFileType(e.target.value),
    [],
  );
  const getExportLink = async () => {
    setExporting(true);
    let baseUrl = isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? magicTableDataUrlV2 : magicTableDataUrl;
    if (radioButtonValue == 1) {
      baseUrl = (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? magicTableDataUrlV2 : magicTableDataUrl).replace(/&search=[^&]*/, '') + `&rows_to_export=${totalCount}`;
    } else if (radioButtonValue == 2) {
      baseUrl = baseUrl + `&rows_to_export=${(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count}`;
    } else if (radioButtonValue == 3) {
      baseUrl = baseUrl + `&rows_to_export=${customRows}`;
    }
    if (isMagicTool) {
      baseUrl = baseUrl + '&export=true';
    }
    try {
      if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
        await downloadExportFileV2(
          `${baseUrl}`,
          `${isMagicTool ? 'KMT' : 'KR'}_${moment().format('YYYY-MM-DD')}.${fileType === 'googleSheset'? 'xlsx': 'csv'}`,
          fileType === 'googleSheset'? true: false,
        );
      } else {
        await downloadExportFile(
          `${baseUrl}&${fileType === 'googleSheset'? 'export_to_google_sheets': 'export_to_csv'}=1`,
          `${isMagicTool ? 'KMT' : 'KR'}_${moment().format('YYYY-MM-DD')}.${fileType === 'googleSheset'? 'xlsx': 'csv'}`,
          fileType === 'googleSheset'? true: false,
        );
      }
      setTimeout(() => {
        setExporting(false);
      }, 2000);
    } catch (error) {
      setExporting(false);
    }
  };

  const exportHandle = () => {
    if (router?.pathname?.includes('public')) {
      setAuthModal(true, false);
    } else {
      setPopoverVisibile(!popoverVisibile);
      setCustomRows(1);
    }
  };

  const popoverContent = (
    <PopoverContent >
      <div className='expTitle'>Export data</div>
      <Radio.Group onChange={e => onChangeRadioButton(e)} value={radioButtonValue}>
        <Space direction='vertical'>
          <Radio value={1}>All Rows ({ totalCount })</Radio>
          <Radio value={3} >
            <span className='customWrap'>Custom <input className='customInput' type='number' placeholder={`Up to ${totalCount}`}
              value={Number(customRows).toString()} min='1'
              onChange={e => {
                if (Number(e.target.value) > 0 && Number(e.target.value) <= totalCount) {
                  setCustomRows(Number(e.target.value));
                }
              }} />
            </span></Radio>
        </Space>
      </Radio.Group>
      <div className='explabel'>EXPORT TO:</div>
      <Radio.Group onChange={e => onChangeFileType(e)}
        value={fileType}>
        <Space direction='vertical'>
          {(!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && <Radio value={'googleSheset'}>Google Sheets</Radio>}
          <Radio value={'csv'}>CSV file</Radio>
        </Space>
      </Radio.Group>
      <BtnWrapper>
        <ButtonCom
          buttonType='transparent'
          disabled={false}
          className='buttonstyle'
          style={{backgroundColor: '#7F4EAD', color: '#ffff', marginRight: '10px', justifyContent: 'center'}}
          onClick={() => {
            getExportLink();
            setPopoverVisibile(false);
          }}
        > <div>{exporting ?<Spin indicator={antIconWt} /> : 'Export'}</div>
        </ButtonCom>
        <ButtonCom
          buttonType='transparent'
          disabled={false}
          className='buttonstyle'
          style={{backgroundColor: '#F9F9FB', color: '#4E5156'}}
          onClick={()=> setPopoverVisibile(false)}
        > <div>Cancel</div>
        </ButtonCom>
      </BtnWrapper>
    </PopoverContent>
  );

  const handleUpdateState = async (data: any, updatedListname: string | null) => {
    initialLoad();
    const response = await loadKeywordDetailList(listId);
    const keyword = response?.keywords[0]?.keyword;
    const locationIdParam = (data?.location_id === null || data?.location_id === '') ? '' : data?.location_id || locationId || '';
    const countryCodeParam = (data?.country_code || data?.country_code === '') ? data?.country_code : countryCode || '';
    const countryNameParam = (data?.country_name || data?.country_name === '') ? data?.country_name : countryName || '';
    router.push(`/research/keyword-researcher-magic/${listId}/${keyword?.replaceAll(' ', '+')}?${updatedListname ? `listName=${updatedListname}` : ''}&locationId=${locationIdParam}&countryCode=${countryCodeParam}&countryName=${countryNameParam}`);
  };
  const isPublicPage = router?.pathname?.includes('public');
  const publicHash = router?.query?.public_hash;

  const handleTableChange = async (pagination, filters, sorter) => {
    const {column, order} = sorter;
    const {sortFieldName} = column || {};
    const sorterKey = order ? `${order == 'descend' ? '-' : ''}${sortFieldName}` : '';
    setActiveSort(sorterKey);
    setMagicTableParams({
      ...magicTableParams,
      ordering: sorterKey,
    });
    if (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions')) {
      loadTermSearchMagicDetails({
        keyword: keyword, search,
        location_id: locationId,
        country_code: countryCode?.toLowerCase(),
        ...(tableName == 'questions' && {question_search: true}),
      }, extendedTerm);
    } else {
      loadTermsMatchMagicDetails({keyword: keyword, listId: listId, search}, extendedTerm);
    }
  };

  return (
    <MainContainer>
      <div className='container'>
        {isPublicKeywordMagicV2() ? <ChartOverlayBanner bannerWidth={'100%'} bannerHeight={'87%'} left={'0'} top={'60px'}/> : ''}
        <FlexWrapper>
          <HeadingWrapper>TERMS</HeadingWrapper>
          {showSvColumn && <HeadingWrapper style={{paddingRight: '12px'}}>SEARCH VOLUME</HeadingWrapper>}
        </FlexWrapper>
        <div style={{height: 'calc(100% - 60px)'}}>
          {loadingMagicTreeUrlV2 ? <SkeletonRingLoader /> :
            loadingMagicTreeV2 || treeList?.length ? (treeList?.length ? handleRenderCollapse(treeList) : <SkeletonRingLoader />) : <Empty description={'No data'} style={{color: '#4e5156', marginTop: '50px'}}/>}
        </div>
      </div>
      <SecondContainer>
        <FilterContainer>
          <StyledHeaderWrapper>
            <StyledLeftWrapper>
              <p>Selected:
                <SelectedSpan>{selectedKeyword.length}</SelectedSpan>
                {selectedKeyword.length ? <StyledDeselect onClick={()=> setSelectedKeyword([]) }>Deselect all</StyledDeselect> : ''}
              </p>
              {isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') && !magicTableLoadingV2 && kmtTermsSearchFilter?.filter(z => z?.active)?.length ? <p>Filtered keywords:
                <SelectedSpan>{numberWithCommas(getMagicTableDataV2?.count)}</SelectedSpan>
              </p> : null}
              {(!isMagicTool || (isMagicTool && (tableName && tableName !== 'keyword_variation' && tableName !== 'questions'))) && <p>
                <Tooltip color='#121212' title={!(getMagicTableData?.results?.filter(result => !result?.searchIntentList?.length))?.length ? 'All search intents are already visible' : selectedKeyword.length ? '' : 'Please select atleast one keyword to show Search Intent'}>
                  <div><ButtonStyled disabled={fetchingSearchIntent || !(getMagicTableData?.results?.filter(result => !result?.searchIntentList?.length))?.length} onClick={() => selectedKeyword.length && !fetchingSearchIntent && handleBulkRefetchSearchIntentList(selectedKeyword)} loading={fetchingSearchIntent}>
                    Show Search Intent</ButtonStyled></div>
                </Tooltip>
              </p>}
            </StyledLeftWrapper>
            <StyledRightWrapper>
              <AddKeywordDropdownV2
                keList={getKeywordListDetail}
                multipleKeyword={selectedKeyword}
                rankTrackerList={getRankTrackerList?.results}
                setNewKeyword={data => setNewKeyword(data)}
                addToBtn
                buttonVariant='solid'
                buttonColor='green'
                disabled={selectedKeyword.length > 0 ? false : true}
              />
              <Dropdown
                overlay={
                  <ProjectSelectMenu
                    expandIcon={<div></div>}
                    style={{borderRadius: '8px'}}>
                    <div style={{borderRadius: '8px'}}>
                      <p style={{margin: '6px 10px'}}>Select SCA Project:</p>
                      <InfoContainer>
                        <FontAwesomeIcon icon={faCircleInfo}/>
                        <InfoText>Each keyword will be used to create a separate article</InfoText>
                      </InfoContainer>
                      <SearchContainer>
                        <Input
                          style={{marginTop: '3px', color: '#A3A4A4'}}
                          placeholder={'Search...'}
                          onChange={(e: any) => setSearchValue(e.target.value)}
                          prefix={<Search width={15}/>}
                          bordered={false}
                        />
                      </SearchContainer>
                      <ListContainer>
                        {projectsList.filter(v => searchValue?.length ? v?.name?.toLowerCase()?.includes(searchValue?.toLowerCase()) : true)?.map(item => (
                          <MenuItem key={item.id} onChange={e => e.preventDefault()}>
                            <ListItem onClick={() => handleCreateContent(item)}
                              style={{gap: '15px'}}
                            >
                              <Text>
                                <div style={{minWidth: '17px'}}>
                                </div>
                                <div>{item.name}</div>
                              </Text>
                              <Value>{''}</Value>
                            </ListItem>
                          </MenuItem>
                        ))}
                      </ListContainer>
                    </div>
                  </ProjectSelectMenu>}
                trigger={['click']}
              >
                <Tooltip title={selectedKeyword.length > 0 ? '' : 'Select at least 1 keyword in the table to create an article'}>
                  <div>
                    <ButtonWrapper border disabled={selectedKeyword.length > 0 || loader ? false : true} color='textGrayLight' textColor='#121212'>
                      {!loader ? <FontAwesomeIcon icon={faPen} style={{marginRight: '7px'}}/> : <LoadingOutlined style={{fontSize: 13, width: '10px', marginRight: '7px'}} spin />} {!loader ? `Create ${selectedKeyword.length > 0 ? selectedKeyword.length : ''} ${selectedKeyword.length > 1 ? 'articles' : 'article'}` : 'Creating...'}
                    </ButtonWrapper>
                  </div>
                </Tooltip>
              </Dropdown>
              <Dropdown trigger={['click']} placement='bottomLeft' visible={popoverVisibile}
                overlay={
                  <Menu style={{width: 220, borderRadius: '10px', padding: '15px'}}>
                    <div>{popoverContent}</div>
                  </Menu>
                }>
                <ButtonWrapper
                  border
                  loading={isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? (magicTableLoadingV2 || exporting) : (magicTableLoading || exporting)}
                  disabled={isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? (magicTableLoadingV2 || exporting) : (magicTableLoading || exporting)}
                  color='textGrayLight'
                  textColor='#121212'
                  onClick={exportHandle}>
                  <FontAwesomeIcon icon={faFileArrowDown}/>&nbsp;Export
                </ButtonWrapper>
              </Dropdown>
            </StyledRightWrapper>
          </StyledHeaderWrapper>
        </FilterContainer>
        <TableStyled>
          <WrapperTable ref={tableRef} bulkStyle={selectedKeyword?.length > 0} className='getTableId'>
            {(isPublicPage && pageNumber>=2) && <ChartOverlayBanner bannerWidth={'100%'} bannerHeight={'92%'} left={'0'} top={'50px'} isKmt={true}/>}
            <Table
              columns={columns(isMagicTool)?.filter(item => Object.keys(item).length !== 0)}
              dataSource={(isPublicKeywordMagicV2() && pageNumber < 2) ?
                (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.results?.slice(0, 5) :
                (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.results}
              loading={
                isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ?
                  (magicTableLoadingV2 || getMagicTableDataV2?.shouldRepoll || getMagicTableDataV2?.shouldRepoll == null || getMagicTableDataV2?.shouldRepoll == undefined) :
                  magicTableLoading
              }
              loadingRows={10}
              pagination={false}
              onChange={isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? handleTableChange : () => {}}
            />
            {isPublicKeywordMagicV2() && <>
              {pageNumber < 2 && <>
                {(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.results?.length < 5 ?
                  <ChartOverlayBanner bannerWidth={'100%'} bannerHeight={'90%'} left={'0'} top={'260px'}/> : <ChartOverlayBanner bannerWidth={'100%'} bannerHeight={'100%'} left={'0'} top={'218px'}/>}
              </>}
            </>}
          </WrapperTable>
          <PaginationStyled
            onChange={handlePaginationChange}
            total={(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count > 10000 ? 10000 :
              (isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count}
            showTenThousandPlus={(isMagicTool && (!tableName || tableName == 'keyword_variation' || tableName == 'questions') ? getMagicTableDataV2 : getMagicTableData)?.count > 10000}
            pageSize={100}
            current={magicTableParams?.page}
            showSizeChanger={false}
          />
        </TableStyled>
      </SecondContainer>
      <CreateList
        title={createListData?.title}
        isRecord={createListData?.isRecord}
        buttonName={createListData?.buttonName}
        listName={createListData?.listName}
        setListName={setListName}
        setNewKeyword={setNewKeyword}
        isKMTPage={true}
        loadPageData={handleUpdateState}
        newKeyword={createListData?.newKeyword}
        selectedCountry={createListData?.selectedCountry}
        setSelectedCountry={setSelectedCountry}/>
      <KeDeleteModal isOpen={openKeywordDeleteModal} onDeleteKeyword={onDeleteKeyword} closeModal={closeModal} loading={deleteKeywordLoading}/>

    </MainContainer>
  );
});

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #F9F9FB;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  display: flex;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
  .container {
    width: 300px;
    background-color: #F9F9FB;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 100%;
  }
  }
`;

const LinkWrapper = styled.a`
&:hover{
  text-decoration: underline;
}
`;
const ButtonWrapper = styled(Button)<{border?: boolean}>`
  margin-top: 15px;
  margin-bottom: 15px;
  margin-right: 0;
  width: fit-content;
  height: 32px;
  border: ${p => p?.border ? '1px solid #E8E8E8' : ''};
  background: ${p => p?.border ? '#F7F7F8' : ''};
  &:hover {
    color:  ${p => p?.border ? '#121212' : ''};
  }
`;

const WrapperTable = styled.div<{bulkStyle: boolean}>`
  position: relative;
  .ant-table-content{
    max-height: none !important;
  }
  ${p => p.bulkStyle ? `.ant-table-body {
      margin-top: 70px !important;
    }` : ''}
    .ant-table-body {    
    &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
  }
    .ant-table-tbody {
     .ant-table-cell {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
`;

const SecondContainer = styled.div`
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  width: calc(100% - 300px);
  padding: 0 10px;
  background-color: #fff;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding-top: 16px;
  }
`;

const FilterContainer = styled.div`
  background: #fff;
  border-bottom: 0 !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const StyledHeaderWrapper = styled.div`
  min-height: 60px !important;  
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  .common-component-input {
    background-color: #fff !important;
    &::placeholder {
      background-color: #fff !important;
    }
  }
`;

const HeadingWrapper = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #121212;
`;

const PillContainer = styled.div<{background: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 12px 8px;
  height: 32px;
  width: fit-content;
  background: ${p => p.background ? p.background : `rgba(244, 67, 67, 0.07)`};
  border-radius: 6px;
`;

const HeaderCheckboxContainer = styled.div`
  margin-left: -7px;
  display: flex;
  align-items: center;
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #7f4ead;
    border-color: #7f4ead;
  }
`;

const FlexWrapper = styled.div`
  align-items: center;
  display: flex;
  background-color: #F9F9FB;
  justify-content: space-between;
  width: 100%;
  padding: 35px 15px 10px 20px;
`;

const CheckbocContainer = styled.div`
  align-items: center;
  display: flex;
  margin-left: 4px;
  a {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsesSpan {
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    margin-left: 11px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #7f4ead;
    border-color: #7f4ead;
  }
`;

const TableStyled = styled.div`
  padding-bottom: 0 !important;
  flex-grow: 1;
  background-color: #fff;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: calc(100% - 60px);
  position: relative;
/* .ant-table-wrapper {
  min-height: 447px;
} */
table tr th {
  background-color: #F9F9FB;
}

.ant-table-column-sorters-with-tooltip:not(:first-child) {
  text-align: center;
}

table {
  padding-left: 10px;
  padding-right: 10px;

  th::before {
    width: 0 !important;
  }

  .ant-table-column-sorter {
    display: flex;
    padding-left: 3px !important;
  }

  .ant-table-column-sorters {
    display: inline-flex !important;
    padding: 5px !important;
  }

  tr td {
    &:first-child {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    }
  }

  .ant-table-tbody {
    tr:nth-child(even) {
      td {
        background: #fff !important;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }

    tr:nth-child(odd) {
      td {
        background: #fff;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }
  }

  .ant-table-thead {
    background: #f7f7f7 !important;

    th {
      background: #f7f7f7 !important;
      color: #121212 !important;
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
      padding: 0 !important;
    }

    .ant-table-cell-fix-left {
      text-align: left !important;

      &:first-child {
        border-bottom-left-radius: 8px !important;
        border-top-left-radius: 8px !important;
      }
    }

    th:first-child {
      background: #f7f7f7 !important;
      border-bottom-left-radius: 8px !important;
      border-top-left-radius: 8px !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:nth-child(2) {
      background: #f7f7f7 !important;
      color: #121212;
      font-size: 12px;
      font-weight: 600;
    }

    th:last-child {
      background-color: #f7f7f7 !important;
      border-bottom-right-radius: 8px !important;
      border-top-right-radius: 8px !important;
      padding-left: 25px !important;
    }
  }

  .ant-table-cell-fix-left-last {
    text-align: left !important;
  }

  tr th {
    height: 50px !important;
    line-height: 22px;
    white-space: nowrap;
  }

  .ant-column-sorters {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  tr td {
    padding-bottom: 15px;
    padding-top: 15px;
    text-align: center;
  }

  tr th:first-child,
  tr td:first-child {
    padding-left: 15px !important;
    padding-right: 25px !important;
  }

  tr th:last-child,
  tr td:last-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
    text-align: center;
  }
}
`;

const CollapseMainScroll = styled.div`
    overflow: auto;
    padding-right: 8px;

    &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
      .ant-collapse-content-box  .collapseStyle {
        height:fit-content !important;
      }
    @media screen and (max-width: 768px) {
    height: auto !important;
  }
`;

const GroupingCollapse = styled(Collapse)`
  background-color: #F9F9FB;
    border: unset !important;
    padding-left: 8px;
    width: 100%;   

    .ant-collapse-header {
       
      align-items: center;
      border-radius: 4px;
      box-shadow: 0 1px 0 #f4f4f4;
      display: flex;
      font-size: 12px;
      padding: 14px 0;
      .ant-collapse-arrow {
        margin-right: 8px !important;
      } 

      &:hover {
        background-color: #E8E8E8;;
      }

    }

    .ant-collapse-item {
      border: unset !important;

      .ant-collapse-content-box {
        padding: 5px 0 !important;
      }
    }

    .ant-collapse-content-active {
      box-shadow: 0 1px 0 #f4f4f4;
    }
    
    .ant-collapse-content {
      p {
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        display: flex;
        font-size: 12px;
        justify-content: space-between;
        margin-bottom: 0 !important;
        padding-bottom: 8px;
        padding-left: 30px;
        padding-right: 16px;
        padding-top: 8px;

        &:hover {
          background-color: #f7f7f8;
        }
      }
    }

    .ant-collapse-item-active {
      & > div:first-child {
        background-color: rgba(255, 133, 54, 0.2);
        border-radius: 4px;
      }
    }
`;

const PanelHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const PaginationStyled = styled(Pagination)`
  padding: 20px 25px;  
  text-align: right;
  border-top: 1px solid #E8E8E8!important;


.ant-pagination-item{
  min-width: 25px !important;
 height:25px !important;
}
.ant-pagination-prev {
  width:25px !important;
 height:25px !important;
}
.ant-pagination-next{
  width:25px !important;
 height:25px !important;
}
.ant-pagination-disabled{
  min-width: 25px !important;
 height:25px !important;
}
.ant-pagination-item-link  span  svg {
  display:flex;
  margin-bottom:2px;
  align-items:center;
  justify-content:center;
}
.ant-pagination-prev{
  min-width:25px !important;
  max-height:25px !important;
}
.ant-pagination-next{
  min-width:25px !important;
  max-height:25px !important;
}
.ant-pagination-options{
  height:25px;
}
.ant-pagination{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top:10px;
  margin-right:15px;
  
}
`;

const SelectedSpan = styled.span`
  font-weight: 600;
  color: #121212;
  margin-left: 5px;
`;
const StyledDeselect = styled.span<{disabled?: boolean}>`
  color: #2D6CCA;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
  margin-left: 10px;
`;
const StyledLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 10px;
  flex-wrap: wrap;
  p {
    color: #4E5156;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
  }
  .ant-btn {
    margin: 0 !important;
  }
`;
const StyledRightWrapper = styled.div`
display: flex;
flex-wrap: wrap;
gap: 10px;
.ant-btn {
  margin: 0px !important;
}
`;
const StyledTooltipHeading = styled.span`
font-size: 14px;
color: #fff;
font-weight: 600;
`;
const TooltipDescription = styled.div`
font-weight: 350;
`;

const PopoverContent = styled.div`
  :global(.ant-radio-checked .ant-radio-inner) {
    border-color: $color-purple-medium !important;
  }

  :global(.ant-radio:hover .ant-radio-inner) {
    border-color: $color-purple-medium !important;
  }

  :global(.ant-radio-checked .ant-radio-inner::after) {
    background-color: $color-purple-medium !important;
  }

  .expTitle {
    color: #121212;
    font-size: 15px;
    line-height: 14px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .explabel {
    color: rgb(163, 164, 164);
    font-size: 12px;
    margin: 8px 0 4px;
  }

  .customWrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    gap: 10px;

    .customInput {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #E8E8E8;
      background: #F9F9FB;
      color: black;
      padding: 4px 8px;
      line-height: 17px;
      &:focus-visible {
        outline: none;
      }
    }
  }  
`;

const BtnWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  .buttonstyle{
    padding: 4px 15px;
  }
`;

const SerchIntnetStyled = styled.div`
  display: flex;
  align-items: center;
`;

const SearchIntentWrapper = styled.div<{cololAndBg: any}>`
  color: ${p=> p?.cololAndBg?.color};
  background: ${p=> p?.cololAndBg?.background} !important;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  margin-left: 5px;
`;

const BlueText = styled.div`
  color: #1890ff;
  cursor: pointer;
  font-weight: 500;
  margin-left: 5px;
`;

const FontAwesomeIconStyled = styled(FontAwesomeIcon)`
  animation: spin infinite 1s linear;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const ButtonStyled = styled(Button)`
  background-color: #2D6CCA !important;
  height: 32px;
  margin-left: 10px;

  &:hover {
    background-color: #2D6CCA !important;
  }
  &:focus {
    background-color: #2D6CCA !important;
  }
  &:disabled {
    background-color: #2D6CCA !important;
    cursor: not-allowed;
  }
`;
